/** The session check could not be made (offline, a 5xx): not a sign-out, so
 * nothing is cleared and nobody is sent to /login. */
export function SessionUnreachable({ onRetry }: { onRetry: () => void }) {
  return (
    <div className="auth-shell">
      <div className="auth-card">
        <div className="panel auth-error-state" role="alert">
          <div className="auth-state-icon">!</div>
          <strong>Can't reach Rivets</strong>
          <span>You're still signed in. Check your connection and try again.</span>
          <button type="button" className="btn btn-primary" onClick={onRetry}>Try again</button>
        </div>
      </div>
    </div>
  );
}
